import React, { useEffect, useState } from "react";
import { ITopMenuItem } from "../../../../types/common.interface";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import {
  APPROVE_PARENT_TRANSACTION,
  FINANCIAL_SUB_TABS,
} from "../../../../values/subTabs";
import { t } from "i18next";
import NotFound from "../../../NotFound";
import PendingParentTransactionContainer from "./screens/Pending/Container";
import SubSubTabs from "../../../../components/SubSubTabsList";
import RejectedParentTransactionContainer from "./screens/Rejected/Container";

type Props = {};

const ApproveParentTransaction = (props: Props) => {
  const currentMenu = window.location.pathname.split("/")[5];

  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState<ITopMenuItem>(
    APPROVE_PARENT_TRANSACTION.find(
      (item) => item.pathname === currentMenu
    ) as ITopMenuItem
  );

  function onTabClick(tab: any) {
    navigate(tab.pathname);
    setSelectedTab(tab);
  }

  useEffect(() => {
    setSelectedTab(
      APPROVE_PARENT_TRANSACTION.find(
        (item) => item.pathname === currentMenu
      ) as ITopMenuItem
    );
  }, [currentMenu]);

  return (
    <section id="setting-screen">
      <SubSubTabs
        tabs={APPROVE_PARENT_TRANSACTION}
        onClick={onTabClick}
        selected={selectedTab as ITopMenuItem}
      />
      <Routes>
        <Route path="/" element={<Navigate to={"pending"} />} />
        <Route
          path="/pending"
          element={<PendingParentTransactionContainer />}
        />
        <Route
          path="/rejected"
          element={<RejectedParentTransactionContainer />}
        />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </section>
  );
};

export default ApproveParentTransaction;
